var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeployApplications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-289 381 32 32",
    style: {
      enableBackground: "new -289 381 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AEA051;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-264.1,407.7h-17.8c-3.5,0-6.4-2.9-6.4-6.4c0-3.2,2.2-5.7,5.3-6.3c-0.1-0.4-0.1-0.8-0.1-1.2 c0-3.5,2.9-6.4,6.4-6.4c1.4,0,2.8,0.5,3.9,1.3c1.4-1.6,3.5-2.6,5.7-2.6c4.2,0,7.6,3.4,7.6,7.6c0,0.9-0.2,1.8-0.5,2.7 c1.4,1.2,2.2,3,2.2,4.8C-257.7,404.9-260.6,407.7-264.1,407.7z M-276.7,389c-2.7,0-4.9,2.2-4.9,4.9c0,0.5,0.1,1.1,0.3,1.6 c0.1,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.4,0.3-0.6,0.3c-2.7,0.1-4.7,2.2-4.7,4.9c0,2.7,2.2,4.9,4.9,4.9h17.8c2.7,0,4.9-2.2,4.9-4.9 c0-1.6-0.8-3.1-2.1-4c-0.3-0.2-0.4-0.6-0.2-0.9c0.4-0.8,0.6-1.7,0.6-2.6c0-3.4-2.7-6.1-6.1-6.1c-2,0-3.9,1-5,2.6 c-0.1,0.2-0.3,0.3-0.6,0.3c-0.2,0-0.4-0.1-0.6-0.2C-274.2,389.5-275.4,389-276.7,389z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -273,
    y: 394,
    className: "st0",
    width: 1.5,
    height: 8.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-275.2,398.1 -276.2,397 -272.2,393 -268.2,397 -269.3,398.1 -272.2,395.1  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeployApplications);
export default __webpack_public_path__ + "static/media/deploy_applications.435e9549c8cb2d8e2435d4ffc955c4e5.svg";
export { ForwardRef as ReactComponent };